export const inputClass =
  'w-full border border-hairline bg-void px-3 py-2 text-sm text-ink placeholder:text-faint transition-colors focus:border-bernstein focus:outline-none disabled:opacity-50'

export const selectClass =
  'w-full border border-hairline bg-void px-3 py-2 text-sm text-ink transition-colors focus:border-bernstein focus:outline-none disabled:opacity-50'

export const primaryButtonClass =
  'tracked-caps bg-bernstein px-6 py-3 text-[11px] text-void transition-colors hover:bg-bernstein-dim disabled:cursor-not-allowed disabled:bg-faint disabled:text-void/60'
